module.exports = __webpack_public_path__ + "build/static/media/star_full.810e9bb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/star_full.svg
// module id = 279
// module chunks = 6